import app from './../index';

export default class ArtikelController {

  constructor($routeParams) {

    this.artikelKategorien = app.api.artikelKategorien.query();

    if ($routeParams.id === "new") {
      this.artikel = new app.api.artikel();
      this.artikel.$resolved = true;
      this.artikel.bestand = 0;
    } else {
      this.artikel = app.api.artikel.get({
        id: $routeParams.id
      });
    }
  }

  getArtikel(name) {
    return app.api.artikel.query({
      bezeichnung: name
    })
      .$promise
      .then((response) => {
        return response.entries;
      });
  }

  save() {
    this.artikel.$save(() => {
      app.$window.history.back();
    });
  }
}

ArtikelController.$inject = ['$routeParams'];



// WEBPACK FOOTER //
// ./app/artikel/artikelController.js